// removed by extract-text-webpack-plugin
module.exports = {"colors":"\"../../styles/variables.css\"","primaryLight":"#ABEAFF","default":"#868686","primary":"#56CCF2","dropdown":"_3JQiPYMmVWA6FrNALd0GHk","user-avatar":"_1IzTShNEw6yQbKeSZLwLV-","trigger":"i1apQP7v2YDi9RsnEDjiw","dropdown__content":"_3xZX3uoAGPx0EdPrOrIXVx"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UserDropdown/UserDropdown.mod.css
// module id = 1016
// module chunks = 0